import { isFilled } from "@prismicio/client";
import { PrismicNextLink } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import { getTextComponents } from "@/helpers";


/**
 * @param {{
 *   article: import("@prismicio/client").Content.GuideListSliceDefaultPrimaryArticlesItem["article"];
 *   index: number;
 * }} props
 */
const GuideListItem = ({ article, index }) => (
  <PrismicNextLink
    prefetch={false}
    field={article}
    className="flex items-center gap-5 rounded-[10px] border border-vert-10 p-5"
  >
    <span
      className="flex text-number-guide text-vert bg-vert-10 w-[48px] h-[48px] rounded-[10px] items-center justify-center"
      aria-hidden
    >
      {index + 1}
    </span>
    {isFilled.richText(article.data?.preview_title) && (
      <PrismicRichText
        field={article.data.preview_title}
        components={{
          heading1: ({ children }) => (
            <h2 className="p-lg-semibold text-bleu flex-1">{children}</h2>
          ),
          heading2: ({ children }) => (
            <h2 className="p-lg-semibold text-bleu flex-1">{children}</h2>
          ),
        }}
      />
    )}
  </PrismicNextLink>
);

/**
 * @typedef {import("@prismicio/client").Content.GuideListSlice} GuideListSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<GuideListSlice>} GuideListProps
 * @type {import("react").FC<GuideListProps>}
 */
const GuideList = ({ slice }) => {
  const { text_intro, articles, text } = slice.primary;

  const filledArticles = Array.isArray(articles)
    ? articles.filter((item) => isFilled.contentRelationship(item.article))
    : [];

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="contre-uno bg-blanc padding-x padding-y-md"
    >
      <div className="framing-sm flex flex-col gap-15 md:gap-20">
        {isFilled.richText(text_intro) && (
          <PrismicRichText field={text_intro} components={{
            paragraph: ({ children }) => (
              <p className="p-lg md:p-xxl text-bleu">{children}</p>
            )
          }} />
        )}

        {filledArticles.length > 0 && (
          <div className="flex flex-col gap-4">
            {filledArticles.map(({ article }, index) => (
              <GuideListItem
                key={article.id ?? `guide-article-${index}`}
                article={article}
                index={index}
              />
            ))}
          </div>
        )}

        {isFilled.richText(text) && (
          <div className="flex flex-col gap-5">
            <PrismicRichText field={text} components={{
              paragraph: ({ children }) => (
                <p className="p-blog text-bleu">{children}</p>
              )
            }} />
          </div>
        )}
      </div>
    </section>
  );
};

export default GuideList;
